export const ReportsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="-1 -1 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 19H13M7 19V14M7 19H1.6C1.26863 19 1 18.7314 1 18.4V14.6C1 14.2686 1.26863 14 1.6 14H7M13 19V7M13 19H18.4C18.7314 19 19 18.7314 19 18.4V1.6C19 1.26863 18.7314 1 18.4 1H13.6C13.2686 1 13 1.26863 13 1.6V7M7 14V7.6C7 7.26863 7.26863 7 7.6 7H13"
      stroke="#444444"
      strokeWidth="1.5"
    />
  </svg>
);
